import React from 'react';
import moment from 'moment';
import {Icons} from '../../assets';
import {Text, TextVariant, TextColor, HtmlTag} from '../typography/text';

export enum TimeStampFormat {
  Relative = 'relative',
  Absolute = 'absolute',
  DateTime = 'datetime',
}

interface TimeStampProps {
  date: Date | string;
  format?: TimeStampFormat;
  showIcon?: boolean;
  className?: string;
}

export const TimeStamp: React.FC<TimeStampProps> = ({date, format = TimeStampFormat.Relative, showIcon = true, className = ''}) => {
  const formatDate = (dateParam: Date | string, formatParam: TimeStampFormat): string => {
    const momentDate = moment.utc(dateParam);

    switch (formatParam) {
      case TimeStampFormat.Relative:
        return momentDate.fromNow();
      case TimeStampFormat.Absolute:
        return momentDate.format('MMM DD, YYYY');
      case TimeStampFormat.DateTime:
        return momentDate.format('MMM DD, YYYY h:mm A') + ' UTC';
      default:
        return momentDate.fromNow();
    }
  };

  const containerClasses = ['flex items-center', className].filter(Boolean).join(' ');

  return (
    <div className={containerClasses}>
      {showIcon && <img src={Icons.CLOCK} alt="Time" className="w-4 h-4 mr-1" />}
      <Text variant={TextVariant.BODY_SMALL} color={TextColor.MUTED} as={HtmlTag.SPAN}>
        {formatDate(date, format)}
      </Text>
    </div>
  );
};
